<script lang="ts">
	import { querystring } from 'svelte-spa-router';
	import { push } from 'svelte-spa-router';
	import { Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';

	import LinkingProcessStartShelly from '../components/Integrations/AlexaAppLinking/LinkingProcessStartShelly.svelte';
	import LinkingProcessStartAlexa from '../components/Integrations/AlexaAppLinking/LinkingProcessStartAlexa.svelte';
	import AppToAppAlexa from './AppToAppAlexa.svelte';

	import { parseQuerystring } from 'src/helpers/utilities';
	import { format } from 'svelte-i18n';

	console.log('$querystring', parseQuerystring($querystring));

	let { code, error, error_description, client_id, state, redirect_uri, response_type, scope } =
		parseQuerystring($querystring);

	let params = {
		client_id,
		state,
		redirect_uri,
		response_type,
		scope,
	};
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('label_amazon_alexa', { default: 'Amazon Alexa' })}
		slot="breadcrumbs"
		links={[
			{ label: 'Integrations', onClick: () => push('/settings/integrations') },
			{ label: 'Amazon Alexa' },
		]}
	/>
</Toolbar>

{#if code || error}
	<AppToAppAlexa />
{:else if client_id && state && redirect_uri}
	<LinkingProcessStartAlexa {...params} />
{:else}
	<LinkingProcessStartShelly bottomMargin />
{/if}
